import { render, staticRenderFns } from "./HolidayRule.vue?vue&type=template&id=3967593b&scoped=true"
import script from "./HolidayRule.vue?vue&type=script&lang=js"
export * from "./HolidayRule.vue?vue&type=script&lang=js"
import style0 from "./HolidayRule.vue?vue&type=style&index=0&id=3967593b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3967593b",
  null
  
)

export default component.exports